module.exports = __webpack_public_path__ + "img/652.29d5ffd5.png";